import { create } from 'zustand'

interface ModalCyTState {
  modalCyT: {
    isOpen: boolean
    onSuccess?: () => void
  }
  setModalCyT: (modalCyT: { isOpen: boolean; onSuccess?: () => void }) => void
  reset: () => void
}

const initialState = {
  modalCyT: {
    isOpen: false
  }
}

export const useModalCyTStore = create<ModalCyTState>()((set) => ({
  ...initialState,
  setModalCyT: (modalCyT) => set({ modalCyT }),
  reset: () =>
    set({
      modalCyT: initialState.modalCyT
    })
}))
